import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isHidden"];
import React, { Suspense } from 'react';
import { getContentTypeConfig } from './config';

/**
 * Render a content type
 *
 * @param Component
 * @param data
 * @returns {*}
 */
var renderContentType = (Component, data) => {
  return /*#__PURE__*/React.createElement(Component, data, data.children.map((childTreeItem, i) => /*#__PURE__*/React.createElement(ContentTypeFactory, {
    key: i,
    data: childTreeItem
  })));
};

/**
 * Create an instance of a content type component based on configuration
 *
 * @param data
 * @returns {*}
 * @constructor
 */
var ContentTypeFactory = _ref => {
  var {
    data
  } = _ref;
  var {
      isHidden
    } = data,
    props = _objectWithoutProperties(data, _excluded);
  if (isHidden) {
    return null;
  }
  var contentTypeConfig = getContentTypeConfig(props.contentType);
  if (contentTypeConfig && contentTypeConfig.component) {
    return /*#__PURE__*/React.createElement(Suspense, {
      fallback: ''
    }, renderContentType(contentTypeConfig.component, props));
  }
  return null;
};
export default ContentTypeFactory;